import { CoreError } from 'shared/utils/errors/CoreError';

import { useDefaultErrorStrings } from './useDefaultErrorStrings';

/**
 * Creates an empty CoreError w. a default title and message
 * this hook may be useful to cover unknown local errors we don't have
 * a defined experience around.
 */
const useDefaultError = (props?: { code?: string }): CoreError => {
  const { code } = props || {};
  const { defaultTitle, defaultMessage } = useDefaultErrorStrings();
  return {
    title: defaultTitle,
    message: defaultMessage,
    code,
  };
};

export default useDefaultError;
